import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/shared/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
/* Last line of defence. The per-page boundaries inside the shells handle
   almost everything; this catches a throw in the providers or the router
   itself, which would otherwise leave a blank document. */
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
